<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_17",
      next: "P_19",
      topic: "",
      progress: false
    };
  },
  methods: {

  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(:back='last') {{topic}}
            v-card-text.text-xs-center.label16tt.withDivider(style='color:#F7893B')
              | ESCENARIO
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md6)
                v-card.pa-5(flat, height='100%', color='secondary')
                  v-card-text.parrafoDestacadoW.pl-5.py-3.mt-3
                    | Cuando sea hora de elegir tu crédito, ¿cómo sabrás cuál es el ideal para ti? 
                  v-card-text.parrafoDestacadoW.pl-5.py-3.mt-3
                    | ¿Sabrás en qué fijarte para elegirlo? 
                  v-card-text.parrafoDestacadoW.pl-5.py-3.mt-3
                    | A continuación, encontrarás las características de cada tipo de crédito y los aspectos a tomar en cuenta para elegirlo. 
              v-flex.ma-0.pa-0(xs12, md6)
                v-card(flat, text-xs-start)
                  v-img(height='576px', :src='require("@/assets/TCC-L6-Pagina2 A.png")')
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage(next)")

                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


